import { queryClient } from '@app/config/queryClient'
import { enableUseCase } from '@app/domains/useCases/services/useCases.service'
import { UseCase } from '@app/domains/useCases/types/useCases.types'
import { useMutation } from '@tanstack/react-query'

export const useEnableUseCase = () => {
  return useMutation({
    mutationFn: ({ slug, enabled }: { slug: string; enabled: boolean }) =>
      enableUseCase(slug, enabled),

    onMutate: async ({ slug, enabled }) => {
      await queryClient.cancelQueries({ queryKey: ['use-cases'] })

      const previousUseCases = queryClient.getQueryData<UseCase[]>(['use-cases'])

      queryClient.setQueryData<UseCase[]>(['use-cases'], (old) => {
        if (!old) return old

        return old.map((uc) => (uc.slug === slug ? { ...uc, enabled } : uc))
      })

      return { previousUseCases }
    },

    onError: (_err, _variables, context) => {
      if (context?.previousUseCases) {
        queryClient.setQueryData(['use-cases'], context.previousUseCases)
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['use-cases'] })
    },
  })
}
